var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2757_6096",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2757_6096)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H23V23H0V0Z",
    fill: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V7.66667H23V0H0Z",
    fill: "#E31C1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.3335V23.0002H23V15.3335H0Z",
    fill: "#3D57DB"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-1_2757_6096",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -4.9165,
    width: 25,
    height: 33,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -1,
    y: -4.9165,
    width: 25,
    height: 33
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0893 9.5835L0 -1.9165V24.9168L11.0893 13.4168H23V9.5835H11.0893Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0893 9.5835L0 -1.9165V24.9168L11.0893 13.4168H23V9.5835H11.0893Z",
    fill: "#5DA923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -1.9165L0.719844 -2.61064L-1 -4.39418V-1.9165H0ZM11.0893 9.5835L10.3694 10.2776L10.6644 10.5835H11.0893V9.5835ZM0 24.9168H-1V27.3945L0.719844 25.611L0 24.9168ZM11.0893 13.4168V12.4168H10.6644L10.3694 12.7227L11.0893 13.4168ZM23 13.4168V14.4168H24V13.4168H23ZM23 9.5835H24V8.5835H23V9.5835ZM-0.719844 -1.22237L10.3694 10.2776L11.8091 8.88936L0.719844 -2.61064L-0.719844 -1.22237ZM1 24.9168V-1.9165H-1V24.9168H1ZM10.3694 12.7227L-0.719844 24.2227L0.719844 25.611L11.8091 14.111L10.3694 12.7227ZM23 12.4168H11.0893V14.4168H23V12.4168ZM22 9.5835V13.4168H24V9.5835H22ZM11.0893 10.5835H23V8.5835H11.0893V10.5835Z",
    fill: "#FAFDFF",
    mask: "url(#path-6-outside-1_2757_6096)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.353553 5.39645L-0.5 4.54289V5.75V17.25V18.4571L0.353553 17.6036L6.10355 11.8536L6.45711 11.5L6.10355 11.1464L0.353553 5.39645Z",
    fill: "#262626",
    stroke: "#FFCC00"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2757_6096)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2757_6096",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZar);
export default __webpack_public_path__ + "static/media/ZAR.69679a91f937b872fe6da1b7aa313198.svg";
export { ForwardRef as ReactComponent };